import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { register, SwiperContainer } from 'swiper/element/bundle';
register();
export interface ShopAndShipCarouselItemInterface {
  content: string;
  userName: string;
  userCity: string;
  userAvatar: string;
}
@Component({
  selector: 'lp-countries-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css'],
})
export class ShopAndShipCarouselComponent implements OnInit, AfterViewInit {

  // Resize Update Check 

  constructor() {}
  @Input() carouselSlidesSet: ShopAndShipCarouselItemInterface[] = [];
  @Input() carouselTitle: string;

  @ViewChild('swiper') swiper: ElementRef<SwiperContainer>;
  currentIndex: any;

  ngOnInit(): void {
    
  }

  initSwiper() {
    const swiperEl = document.getElementById('lp-countries-carousel-swiper');
    Object.assign(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      slidesPerGroup: 1,
      breakpoints: {
        '420': {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerGroup: 1,
        },
        '576': {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerGroup: 2,
        },
        '768': {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
        '992': {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
        '1200': {
          slidesPerView: 3.5,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
      },
    });
    const buttonNextEl = document.getElementById('carousel-next-btn');
    buttonNextEl.addEventListener('click', () => {
      swiperEl['swiper'].slideNext();
    });

    const buttonPrevEl = document.getElementById('carousel-prev-btn');
    buttonPrevEl.addEventListener('click', () => {
      swiperEl['swiper'].slidePrev();
    });

    setTimeout(() => {
      register();
    }, 100);
  }

  ngAfterViewInit(): void {
    this.initSwiper();
    this.swiper.nativeElement.addEventListener('slidechange', (evt) =>
      this.slideChange(evt)
    );
  }

  slideChange(swiperRef) {
    this.currentIndex = swiperRef.detail[0].activeIndex;
    swiperRef.detail[0].isEnd
      ? this.addOpacityClassToRight()
      : this.removeOpacityClassFromRight();
    swiperRef.detail[0].isBeginning
      ? this.addOpacityClassToLeft()
      : this.removeOpacityClassFromLeft();
  }

  addOpacityClassToLeft() {
    const buttonPrevEl = document.getElementById('carousel-prev-btn');
    buttonPrevEl.classList.add('opacity-50');
  }
  removeOpacityClassFromLeft() {
    const buttonPrevEl = document.getElementById('carousel-prev-btn');
    buttonPrevEl.classList.remove('opacity-50');
  }
  addOpacityClassToRight() {
    const buttonNextEl = document.getElementById('carousel-next-btn');
    buttonNextEl.classList.add('opacity-50');
  }
  removeOpacityClassFromRight() {
    const buttonNextEl = document.getElementById('carousel-next-btn');
    buttonNextEl.classList.remove('opacity-50');
  }
}
